import { useLocation } from 'wouter';
import { Button, Card, CardContent, CardHeader, CardTitle } from "@/ui";
import { CheckCircle, Mail, Calendar, ArrowLeft } from 'lucide-react';

export default function DemoThankYou() {
  const [, setLocation] = useLocation();

  return (
    <div>
      <main className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        {/* Success Message */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-green-600" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            Thank You for Your Interest!
          </h1>
          <p className="text-xl text-muted-foreground mb-8">
            Your demo request has been submitted successfully.
          </p>
        </div>

        {/* Information Card */}
        <Card className="max-w-2xl mx-auto mb-8">
          <CardHeader>
            <CardTitle className="text-2xl text-center">What Happens Next?</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <Mail className="w-4 h-4 text-blue-600" />
              </div>
              <div>
                <h3 className="font-semibold text-lg mb-2">Email Confirmation</h3>
                <p className="text-muted-foreground">
                  You'll receive a confirmation email within the next few minutes with your demo request details.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <Mail className="w-4 h-4 text-blue-600" />
              </div>
              <div>
                <h3 className="font-semibold text-lg mb-2">Team Contact</h3>
                <p className="text-muted-foreground">
                  Our team will contact you within 24 hours to confirm your demo appointment and discuss your specific needs.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <Calendar className="w-4 h-4 text-blue-600" />
              </div>
              <div>
                <h3 className="font-semibold text-lg mb-2">Demo Scheduling</h3>
                <p className="text-muted-foreground">
                  We'll work with you to schedule a convenient time for your personalized demo based on your preferences.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Contact Information */}
        <Card className="max-w-2xl mx-auto mb-8">
          <CardHeader>
            <CardTitle className="text-xl text-center">Need Immediate Assistance?</CardTitle>
          </CardHeader>
          <CardContent className="text-center">
            <p className="text-muted-foreground mb-4">
              If you have any urgent questions or need to modify your demo request, please don't hesitate to contact us.
            </p>
            <div className="space-y-2">
              <p className="font-medium">
                Email: <a href="mailto:demo@aiscendus.com" className="text-primary hover:underline">demo@aiscendus.com</a>
              </p>
            </div>
          </CardContent>
        </Card>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            variant="outline"
            onClick={() => setLocation('/')}
            className="px-8 py-3"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
          <Button
            onClick={() => setLocation('/platform')}
            className="px-8 py-3"
          >
            Learn More About Our Platform
          </Button>
        </div>
      </main>
    </div>
  );
}
